import { render, staticRenderFns } from "./ChargingPointDetailDiscontinuities.vue?vue&type=template&id=12d84ee6"
import script from "./ChargingPointDetailDiscontinuities.vue?vue&type=script&lang=js"
export * from "./ChargingPointDetailDiscontinuities.vue?vue&type=script&lang=js"
import style0 from "./ChargingPointDetailDiscontinuities.vue?vue&type=style&index=0&id=12d84ee6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports